export enum TemperatureType {
    Creative = 'Creative',
    Balanced = 'Balanced',
    Precise = 'Precise',
}
